import {forwardRef, type ReactNode} from 'react'
import {NavLink, type NavLinkProps} from 'react-router-dom'
import type {VariantProps} from 'class-variance-authority'
import {Button, type buttonVariants} from '@components/ui/button'

export type ButtonNavLinkProps = Omit<NavLinkProps, 'children' | 'className' | 'style'> &
    VariantProps<typeof buttonVariants> & {
        children?: ReactNode
        className?: string
        disabled?: boolean
    }

export const ButtonNavLink = forwardRef<HTMLAnchorElement, ButtonNavLinkProps>(
    ({className, variant, size, shape, children, disabled, ...navLinkProps}, ref) => (
        <Button
            className={className}
            disabled={disabled}
            nativeButton={false}
            render={
                disabled ? (
                    <a ref={ref} />
                ) : (
                    <NavLink
                        {...navLinkProps}
                        ref={ref}
                        onClick={event => {
                            if (disabled) {
                                event.preventDefault()
                                event.stopPropagation()
                            } else {
                                navLinkProps.onClick?.(event)
                            }
                        }}
                    />
                )
            }
            shape={shape}
            size={size}
            variant={variant}
        >
            {children}
        </Button>
    )
)
ButtonNavLink.displayName = 'ButtonNavLink'
